const authQueryKeys = {
  oauthClient: (clientId) => [
    "oauth-client",
    clientId
  ],
  oauthConnections: [
    "oauth-connections"
  ]
};

export { authQueryKeys };
//# sourceMappingURL=authQueryKeys.js.map
